import {asyncType} from '../helpers';

export const sftpUserReducerKey = 'sftpUsers';

export default {
   MOVE_SFTP_USER: asyncType(`${sftpUserReducerKey}/MOVE_SFTP_USER`),
   MOVE_SFTP_GROUP: asyncType(`${sftpUserReducerKey}/MOVE_SFTP_GROUP`),

   EXPAND_VFS_NODE: asyncType(`${sftpUserReducerKey}/EXPAND_VFS_NODE`),
   HIDE_LOADER: `${sftpUserReducerKey}/HIDE_LOADER`,
   GET_REFS_SSH: asyncType(`${sftpUserReducerKey}/GET_REFS_SSH`),
};
